import AutomationsPage from "components/Automations/AutomationsPage";
import { OrgAdminShell } from "pages/org-performance/OrgAdminPage";

/** Automations, for admins: reached from the profile menu, under Message Templates. */
export default function AutomationsRoute() {
  return (
    <OrgAdminShell>
      {(orgId) => <AutomationsPage key={orgId} orgId={orgId} />}
    </OrgAdminShell>
  );
}
